<div class="modal-header">
  {{this.project.name}}
</div>

<div class="modal-body">
    <div class="row mb-1">
      <div class="col-3">
        <span i18n="@@name-label">Name:</span>
      </div>
      <div class="col">
        <input
          pInputText
          pSize="small"
          fluid
          [disabled]="!this.canChange(project)"
          type="text"
          [(ngModel)]="this.name"
        >
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <span i18n="@@description-label">Beschreibung:</span>
      </div>
      <div class="col">
        <textarea
          pInputTextarea
          fluid
          rows="3"
          [disabled]="!this.canChange(project)"
          [(ngModel)]="this.description"
        ></textarea>
      </div>
    </div>
    <h5>
      <span i18n="@@access-control-workmode">Zusammenarbeit</span>
    </h5>
    <div
      class="row align-items-center mt-3"
      style="margin-bottom: 10px;"
    >
      <div class="col-3">
        <span i18n="@@edit-in-org">Bearbeitbar von:</span>
      </div>
      <div class="col">
        <p-select
          [disabled]="!this.canChange(project) && this.loginService.loggedInUser?._id !== project.creator"
          [options]="editModeOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.editMode"
        ></p-select>
      </div>
    </div>
    <div class="row align-items-center mt3">
      <div class="col-3">
        <span i18n="@@share-in-org">Teilen mit:</span>
        <app-hint i18n="@@hint-share-in-org">Macht den Bot für alle Mitglieder der ausgewählten Organisation
          sichtbar und nutzbar</app-hint>
      </div>
      <div class="col">
        <p-select
          [disabled]="!this.canChange(project)"
          [options]="orgShareOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.orgShort"
        ></p-select>
      </div>
    </div>
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="primary"
    label="Speichern"
    i18n-label="@@save"
    (onClick)="this.updateProject()"
  ></p-button>
</div>